function initialState () {
  return {
    templates: [],
    rights: {}
  }
}

export function RESET (state) {
  // acquire initial state
  const s = initialState()
  Object.keys(s).forEach(key => {
    state[key] = s[key]
  })
}

export function SET_USER (state, user) {
  state.user = user
}

export function SET_AUTH (state, authentication) {
  state.authentication = authentication
}

export function SET_PROFILE_PHOTO (state, path) {
  state.parantion.user.user.profile_photo = path
}

export function SET_TEMPLATES (state, templates) {
  state.templates = templates
}

export function CLEAN_DEFAULT (state) {
  state.user = {}
  state.templates = []
}

export function SET_RIGHT (state, rights) {
  state.rights = rights
}

